import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { Urls } from 'src/app/helpers/urls';

@Injectable({
  providedIn: 'root'
})
export class ActionParamService {

  url = new Urls();
  apiUrl: string;

  constructor(
    private httpclient: HttpClient
  ) {
      this.apiUrl = this.url.apiUrl;
  }

  getActionParams(actionid, paramname) {
    // tslint:disable-next-line: max-line-length
    const url = this.apiUrl + '/api/actiondefparam/' + actionid + '/' + paramname + '/';
    return this.httpclient.get<any>(url)
    .pipe(
      tap( // Log the result or error
        error => this.handleError
      )
    );
  }

  private handleError(error: any) {
    throw error;
    return error;
  }

}
